var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    id: "payment-form",
    class: "!mt-5"
};
const _hoisted_2 = {
    key: 0,
    class: "flex w-full items-center justify-center",
    style: { "height": "297px" }
};
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("div", { id: "payment-element" }, [
    /*#__PURE__*/ _createCommentVNode(" Elements will create form elements here | Stripe card details form ")
], -1 /* HOISTED */);
const _hoisted_4 = {
    key: 0,
    class: "!mt-5"
};
import { StripeAppearanceConfig } from '@/helper';
import config from '@/config';
import { InternalToolsService } from '@/service/InternalToolsService';
import { CreditCard01Icon } from '@gohighlevel/ghl-icons/24/outline';
import { UIAlert, UIModal, UIModalFooter, UIModalHeader, UISpin, } from '@gohighlevel/ghl-ui';
import { inject, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
export default /*#__PURE__*/ _defineComponent({
    __name: 'UpdatePaymentMethod',
    props: {
        showModal: {
            type: Boolean,
            required: true,
        },
    },
    emits: ['update:showModal', 'success'],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const { t } = useI18n();
        const company = inject('company');
        const emit = __emit;
        const formLoading = ref(true);
        const savingCard = ref(false);
        const errorMessage = ref();
        watch(() => props.showModal, newValue => {
            if (newValue) {
                errorMessage.value = null;
                initStripeScript();
            }
        });
        let stripe, elements;
        function initStripeScript() {
            formLoading.value = true;
            //
            let stripeScript = document.getElementById('StripeV3Script');
            if (stripeScript)
                createStripePaymentElement();
            else {
                stripeScript = document.createElement('script');
                stripeScript.setAttribute('id', 'StripeV3Script');
                stripeScript.setAttribute('src', 'https://js.stripe.com/v3/');
                document.head.appendChild(stripeScript);
                stripeScript.onload = createStripePaymentElement;
            }
        }
        function createStripePaymentElement() {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    stripe = window.Stripe(config.STRIPE_JS_KEY);
                    const response = yield InternalToolsService.createPaymentIntent({
                        entityId: company.value.id,
                        entityType: 'COMPANY',
                        amount: 1,
                        currency: 'USD',
                        description: 'Add new card: 3DS verification',
                        enable3DS: true,
                        initialCardSetup: true,
                    });
                    const paymentIntent = response.data.paymentIntent;
                    const options = {
                        clientSecret: paymentIntent.clientSecret,
                        appearance: StripeAppearanceConfig,
                        loader: 'never',
                    };
                    elements = stripe.elements(options);
                    const paymentElement = elements.create('payment', {
                        // fields: { billingDetails: { address: 'never' } },
                        wallets: {
                            applePay: 'never',
                            googlePay: 'never',
                        },
                    });
                    paymentElement.mount('#payment-element');
                    paymentElement.on('ready', function () {
                        formLoading.value = false;
                    });
                }
                catch (error) {
                    errorMessage.value = error.message;
                    formLoading.value = false;
                }
            });
        }
        function confirmPayment() {
            var _a, _b;
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    savingCard.value = true;
                    errorMessage.value = null;
                    const { paymentIntent, error } = yield stripe.confirmPayment({
                        //`Elements` instance that was used to create the Payment Element
                        elements,
                        confirmParams: {
                        // return_url: 'https://example.com/order/123/complete',
                        },
                        redirect: 'if_required',
                    });
                    if (error) {
                        // This point will only be reached if there is an immediate error when
                        // confirming the payment. Show error to your customer (for example, payment
                        // details incomplete)
                        if (error.type !== 'validation_error')
                            errorMessage.value = error.message;
                    }
                    else {
                        // add card details to customer
                        yield InternalToolsService.addCard({
                            paymentIntentId: paymentIntent.id,
                            paymentMethodId: paymentIntent.payment_method,
                            entityType: 'COMPANY',
                            entityId: company.value.id,
                        });
                        emit('success');
                        emit('update:showModal', false);
                    }
                }
                catch (error) {
                    errorMessage.value = ((_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message) || error.message;
                }
                finally {
                    savingCard.value = false;
                }
            });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(UIModal), {
                show: __props.showModal,
                width: 570,
                "onUpdate:show": _cache[3] || (_cache[3] = ($event) => (_ctx.$emit('update:showModal', $event)))
            }, {
                header: _withCtx(() => [
                    _createVNode(_unref(UIModalHeader), {
                        title: _unref(t)('billing.update_payment_method'),
                        description: _unref(t)('billing.update_card'),
                        icon: _unref(CreditCard01Icon),
                        type: "primary",
                        onClose: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('update:showModal', false))),
                        id: "NewCardModalHeader"
                    }, null, 8 /* PROPS */, ["title", "description", "icon"])
                ]),
                footer: _withCtx(() => [
                    _createVNode(_unref(UIModalFooter), {
                        id: "PaymentUpdateFooter",
                        type: "primary",
                        positiveText: _unref(t)('common.save'),
                        negativeText: _unref(t)('common.cancel'),
                        onPositiveClick: confirmPayment,
                        onNegativeClick: _cache[2] || (_cache[2] = ($event) => (_ctx.$emit('update:showModal', false))),
                        loading: savingCard.value
                    }, null, 8 /* PROPS */, ["positiveText", "negativeText", "loading"])
                ]),
                default: _withCtx(() => [
                    _createElementVNode("form", _hoisted_1, [
                        (formLoading.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                _createVNode(_unref(UISpin), { size: "large" })
                            ]))
                            : _createCommentVNode("v-if", true),
                        _hoisted_3
                    ]),
                    (errorMessage.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _createVNode(_unref(UIAlert), {
                                type: "error",
                                id: "UpdatePaymentMethodError",
                                onClose: _cache[1] || (_cache[1] = ($event) => (errorMessage.value = ''))
                            }, {
                                title: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(t)('common.error')), 1 /* TEXT */)
                                ]),
                                content: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(errorMessage.value), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                            })
                        ]))
                        : _createCommentVNode("v-if", true)
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["show"]));
        };
    }
});
